package org.moxultimate.topwithmox.dashboard.api

import io.ktor.client.*
import io.ktor.client.request.*
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow
import org.moxultimate.topwithmox.core.base.BaseAPI.baseAPI
import org.moxultimate.topwithmox.core.handler.APIHandler
import org.moxultimate.topwithmox.core.state.APIState
import org.moxultimate.topwithmox.dashboard.data.DashboardLatestResponse

/**
 * DashboardRepository
 * Handles all network calls for the dashboard aggregation endpoint.
 * Follows the same Flow<APIState<T>> pattern used by all other feature repositories.
 *
 * @property httpClient Ktor HttpClient injected via Koin.
 */
class DashboardRepository(private val httpClient: HttpClient) {

    private val baseUrl = "$baseAPI/dashboard/latest"

    /**
     * getLatest
     * Fetches the 3 most recently added items from products, technology, shows, and apps
     * in a single request to GET /dashboard/latest.
     *
     * @return Flow emitting [APIState.Loading] then [APIState.Success] or [APIState.Error].
     */
    fun getLatest(): Flow<APIState<DashboardLatestResponse>> = flow {
        emit(APIState.Loading)
        emit(APIHandler.safeApiCall {
            httpClient.get(baseUrl)
        })
    }
}
